import React, { useState, useContext } from "react";
import { IconClose1 } from "@velaro/velaro-component-lib";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";
import SendMessageLogo from "@velaro/velaro-component-lib/dist/images/velaro_integrations-complete.png";
import { ProfileContext } from "@velaro/velaro-component-lib";

interface IntegrationsNewAppProps {
  onClose: () => void;
}

export default function IntegrationsNewApp({
  onClose
}: IntegrationsNewAppProps) {
  const [appName, setAppName] = useState("");
  const [appNotes, setAppNotes] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [dateSubmitted, setDateSubmitted] = useState("");
  const { profile } = useContext(ProfileContext);
  const api = useApi();
  const isSubmitActive = appName && appNotes;

  async function sendRequestApplication() {
    const response = await api.messaging.post("Test/Application/SendRequest", {
      Username: profile.displayName,
      To: "support@velaro.com",
      From: profile.email,
      ApplicationName: appName,
      ApplicationNotes: appNotes
    });
    const currentDate = new Date().toLocaleDateString("en-US");
    setDateSubmitted(currentDate);
    setSubmitted(false);
  }

  return (
    <div>
      <div className="self-stretch w-full p-6 border-b flex justify-between">
        <div className="text-xl font-medium">
          {submitted ? "Request Submitted" : "Request New App"}
        </div>
        <IconClose1
          className="h-6 w-6 cursor-pointer"
          onClick={() => {
            if (submitted) {
              setAppName("");
              setAppNotes("");
              setSubmitted(false);
              setDateSubmitted("");
            }
            onClose();
          }}
        />
      </div>

      <div className="right-aside-container flex-grow overflow-auto bg-white p-6">
        {submitted ? (
          <div>
            <img
              className="w-40 place-self-center"
              src={SendMessageLogo}
              alt=""
            ></img>
            <div className="justify-start text-lg font-medium text-center">
              Your Request Has Been Submitted!
            </div>
            <div className="self-stretch text-center justify-start">
              <span className="text-sm font-normal font-['Rubik'] leading-none">
                Thanks for your app integration request. Our team is reviewing
                it and will get back to you once we have an update.
                <br />
                <br />
                Requested App:{" "}
              </span>
              <span className="text-sm font-medium font-['Rubik'] leading-none">
                {appName}
                <br />
              </span>
              <span className="text-sm font-normal font-['Rubik'] leading-none">
                Submitted:{" "}
              </span>
              <span className="text-sm font-medium font-['Rubik'] leading-none">
                {dateSubmitted}
                <br />
              </span>
              <span className="text-sm font-normal font-['Rubik'] leading-none">
                <br />
                If you have more details to share, email us at
                support@velaro.com.
              </span>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-5">
            <div>
              <label className="text-slate-800 text-sm font-medium">
                Application Name
              </label>
              <input
                type="text"
                className="px-4 w-full py-2 mt-2 bg-white rounded-lg border border-slate-300 hover:border-gray-500 focus:outline-none focus:border-cornflower-blue-500"
                value={appName}
                placeholder="Enter application name"
                onChange={(e) => setAppName(e.target.value)}
              />
            </div>

            <div>
              <label className="text-slate-800 text-sm font-medium">
                Notes
              </label>
              <textarea
                value={appNotes}
                onChange={(e) => setAppNotes(e.target.value)}
                placeholder="Describe your integration needs"
                className="px-4 w-full py-2 mt-2 bg-white rounded-lg border border-slate-300 hover:border-gray-500 focus:outline-none focus:border-cornflower-blue-500"
                rows={3}
              />
            </div>

            <PrimaryBlueButton
              label="Submit request"
              onClick={sendRequestApplication}
              className={` ${
                !isSubmitActive ? " bg-slate-300 border-slate-300  text-white cursor-not-allowed" : "hover:bg-slate-300 hover:border-slate-500"
              }`}
              disabled={!isSubmitActive}
            />
          </div>
        )}
      </div>
    </div>
  );
}
